import React from 'react'
import { Paper, Box, Typography, Divider } from '@mui/material';
import {
    ComposedChart,
    Line,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from 'recharts';

const HeadquartersQuarterGoalChart = ({ selectedRow, data }) => {
    if (!data) {
        return null
    }
    return (
        <Paper>
            <Box sx={{ display: 'flex', px: 2 }}>
                <Typography variant="subtitle2" component="div">{selectedRow?.dptNm} 분기별 실적 차트</Typography>
            </Box>
            <Divider sx={{ my: 1 }} />
            <Box sx={{ width: '100%', height: '400px', py: 1, mt: 1 }}>
                <ResponsiveContainer width="100%" height="100%">
                    <ComposedChart
                        data={data}
                        margin={{
                            top: 20,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis width={100} />
                        <Tooltip />
                        <Legend />
                        <Line name="목표" type="monotone" dataKey="goal" stroke="#8884d8" />
                        <Bar name="실적" dataKey="result" barSize={20} fill="#82ca9d" />
         
                        {/* <Line name="목표" type="monotone" dataKey="goal" stroke="#8884d8" activeDot={{ r: 8 }} />
                        <Line name="실적" type="monotone" dataKey="result" stroke="#82ca9d" /> */}
                    </ComposedChart>
                </ResponsiveContainer>
            </Box>
        </Paper>
    )
}

export default HeadquartersQuarterGoalChart